"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProject = parseProject;
const board_1 = require("./board");
const schematic_1 = require("./schematic");
const Font_1 = require("../Font");
async function parseProject(def) {
    if (def.type !== 'eagle') {
        throw new Error(`Attempted to parse non-eagle project def: ${def.type}`);
    }
    const project = {
        type: def.type,
        layerSets: {},
        components: {},
        designs: {},
        modules: [],
        warnings: [],
        fonts: {
            fonts: {},
        },
        globalNets: {},
        processingResults: {
            type: 'project-processing',
            message: 'Project processed successfully',
            innerResults: [],
        },
    };
    if (def.name) {
        project.name = def.name;
    }
    for (const [schId, schs] of Object.entries(def.schematics)) {
        const parsed = (0, schematic_1.parseSchematic)(project, await schs.contents.text(), schId);
        for (const parsedSch of parsed) {
            project.designs[parsedSch.designId] = parsedSch;
        }
    }
    for (const [brdId, brd] of Object.entries(def.boards)) {
        const parsed = (0, board_1.parseBoard)(project, await brd.contents.text(), brdId);
        project.designs[parsed.designId] = parsed;
    }
    (0, Font_1.packModelFonts)(project);
    return project;
}
//# sourceMappingURL=project.js.map